import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import Flyer from './Flyer';

const links = [
  {
    title: 'Inicio',
    path: '/',
  },
  {
    title: 'Quienes Somos',
    path: '/quienes-somos',
    subItems: [
      {
        title: 'Junta Directiva',
        path: '/junta-directiva',
      },
      {
        title: 'Beneficios y Como Afiliarse',
        path: '/beneficios-y-afiliacion',
      },
    ],
  },
  {
    title: 'Galería',
    path: '/galeria',
  },
  {
    title: 'Reuniones científicas',
    path: '/eventos',
  },
  {
    title: 'Contáctenos',
    path: '/contactenos',
  },
  {
    title: 'Revista',
    path: 'https://publicaciones.svrid.org.ve/index.php/rid',
    external: true,
  },
];

interface LayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  return (
    <>
      <header>
        <Navbar links={links} />
      </header>
      <Flyer />
      <main className="flex flex-col min-h-screen w-full bg-gray-50 text-gray-800 relative flex-auto">
        {children}
      </main>
      <Footer links={links} />
    </>
  );
}
